import { render, staticRenderFns } from "./radio-button.vue?vue&type=template&id=98ab268a"
import script from "./radio-button.vue?vue&type=script&lang=js"
export * from "./radio-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports